<template>
  <div>
    <loader v-if="loading" />
    <div class="d-flex justify-content-between">
      <div class="d-flex align-items-center flex-wrap mb-3">
        <h4 class="mb-0 mr-2">{{ label }}</h4>
        <small v-if="period"
               class="text-muted ml-2 invoice-date"
               v-text="period" />
      </div>
      <a v-if="resource"
         href="#"
         v-text="resource.title"
         @click.prevent="$emit('resource-select', resource)"/>
    </div>
    <div class="d-flex justify-content-between mb-2">
      <div v-if="status"
           class="bills__text text-capitalize"
           :class="[{'text-success': status === 'paid', 'text-info': status !== 'paid'}]"
           v-text="status" />
      <div v-if="invoiceNumber" class="bills__text bills-id">#{{ invoiceNumber }}</div>
      <div v-if="paymentDueDate && !isPaid"
           class="text-muted text-right">
         {{ $t('billing.paymentDue') }} <span v-text="paymentDueDate" />
      </div>
    </div>
    <br/>
    <div class="bills__wrapper pb-2 mb-3 d-flex justify-content-between align-items-center">
      <span class="text-primary bills__text">{{ $t('billing.description') }}</span>
      <span class="text-primary bills__text">{{ $t('billing.price') }}</span>
    </div>
    <div class="bills__wrapper mb-3">
      <div v-for="(item, index) in items" :key="index">
        <BillExpand :items="item.items"/>
      </div>
    </div>
    <div class="d-flex justify-content-between bills__text mb-3">
      <div class="font-weight-bold">{{$t('billing.total')}}</div>
      <div class="font-weight-bold">{{total}}</div>
    </div>
    <div class="d-flex mt-1 mb-4"
         :class="[{'justify-content-between': !!paymentAbility, 'justify-content-end': !paymentAbility}]">
      <template v-if="paymentAbility">
        <div v-if="invoicePdfUrl"
             class="d-flex flex-row align-items-center">
          <i class="far fa-file-pdf fa-lg ml-1 mr-1 text-primary d-block"></i>
          <a target="_blank" :href="invoicePdfUrl" class="">
            {{ $t('billing.invoicePDF') }}
          </a>
        </div>

        <b-button v-if="stripeCheckout"
                  v-html="getPayButtonHTML"
                  variant="primary"
                  :disabled="isPaid"
                  :class="{success: isPaid, 'opacity-1': isPaid}"
                  @click.prevent="payStripe()"
        />

        <b-button
            v-else
            :class="{success: isPaid, 'opacity-1': isPaid}"
            :disabled="isPaid"
            variant="primary"
            v-html="getPayButtonHTML"
            @click.prevent="payInvoice(id)"
        />
      </template>

      <b-button
          v-if="isFinalised === false"
          :class="{success: isPaid, 'opacity-1': isPaid}"
          :disabled="isPaid"
          variant="primary"
          @click.prevent="finalize(id)"
          v-text="$t('billing.finalize_invoice')" />

    </div>
  </div>
</template>


<script>
import BillExpand from "@/views/billing/BillExpand";

export default {
  name: 'InvoicesInfo',
  components: {BillExpand},
  data() {
    return {
      loading: false,
    }
  },
  props: {
    id: {
      type: [String, Number],
    },
    estimatedTotal: {
      type: [Number, String],
      default: '0'
    },
    total: {
      type: [Number, String],
      default: null,
    },
    isPaid: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: null,
    },
    invoiceNumber: {
      type: String,
      default: null
    },
    invoicePdfUrl: {
      type: String,
      default: ''
    },
    checkoutUrl: {
      type: String,
      default: ''
    },
    items: {
      type: Array,
      default: [],
    },
    paymentDueDate: {
      type: String,
      default: ''
    },
    stripeCheckout: {
      type: Boolean,
      default: true
    },
    period: {
      type: String,
      default: ''
    },
    status: {
      type: String,
      default: ''
    },
    paymentAbility: {
      type: Boolean,
      default: true
    },
    isFinalised: {
      type: [Boolean, Number],
      default: null
    },
    resource: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  mounted () {},
  computed: {
    getPayButtonHTML () {
      return this.isPaid ? `<i class='fas fa-check-circle mr-2'></i>${this.$t('billing.paid_up')}`: this.$t('billing.process_payment')
    },
    showPayManually () {
      return !this.isPaid && this.$store.getters['auth/user'].role === 'root';
    }
  },
  methods: {
    payStripe() {
      window.open(this.checkoutUrl);
    },
    finalize(id) {
      this.loading = true;
      return this.putData(`resources/pricing/invoice/${id}/finalize`, null, false)
          .then(({ data }) => {
            if (data && data.item && data.item.is_finalized) {
              this.$emit('finalized', true);
            }
          }).catch((error) => {
            if (error && error.response) {
              this.$noty.error(error.response.data.error_description);
            }
          }).finally(() => this.loading = false);
    },
    payInvoice(id) {
      this.loading = true;
      return this.putData(`resources/${this.$store.getters['resource/currentResource'].key}/pricing/invoice/${id}/pay`, null, false)
                 .then(({ data }) => {
                   if (data.success) {
                     this.$emit('paid', true);
                   }
                 }).catch((error) => {
                    if (error && error.response) {
                      this.$noty.error(error.response.data.error_description);
                    }
                 }).finally(() => this.loading = false);
    }
  }
}
</script>